export default {
  'about.eyebrow': 'Get to Know Us',
  'about.heroTitle': 'About Vietnam Travel',
  'about.heroSubtitle': "We don't just show you Vietnam — we help you feel it, live it, and fall in love with every moment of your journey.",
  'about.home': 'Home',
  'about.aboutUs': 'About Us',
  'about.storyEyebrow': 'Our Story',
  'about.storyTitleA': 'Born From a Passion for',
  'about.storyTitleB': "Vietnam's Beauty",
  'about.storyP1': 'Vietnam Travel was founded in 2011 by a group of passionate local guides who believed that traveling Vietnam should be more than just checking off tourist spots. We wanted to create experiences that connect travelers with the real heart and soul of this incredible country.',
  'about.storyP2': "What started as a small team of 5 guides in Hanoi has grown into one of Vietnam's most trusted tour operators, with offices across the country and a team of over 80 dedicated professionals.",
  'about.storyP3': 'Despite our growth, our core belief remains unchanged: every traveler deserves to experience Vietnam not as a tourist, but as a welcomed guest. We craft journeys that blend iconic landmarks with hidden gems, creating memories that last a lifetime.',
  'about.quote': "To us, travel is not about the destination it's about the people you meet, the stories you hear, and the moments that take your breath away.",
  'about.statsTitle': 'Our Journey in Numbers',
  'about.statsSubtitle': 'Over a decade of creating unforgettable travel experiences across Vietnam.',
  'about.whyEyebrow': 'Why Travel With Us',
  'about.whyTitleA': 'What Makes Us',
  'about.whyTitleB': 'Different',
  'about.whySubtitle': 'We go beyond ordinary tours to deliver extraordinary experiences that you will treasure forever.',
  'about.teamEyebrow': 'Meet The Team',
  'about.teamTitleA': 'The People Behind',
  'about.teamTitleB': 'Your Journey',
  'about.teamSubtitle': 'Passionate locals who live and breathe Vietnam ready to craft your perfect adventure.',
  'about.ctaTitle': 'Ready to Explore Vietnam With Us?',
  'about.ctaSubtitle': "Let our local experts craft your dream journey. Whether it's your first visit or your tenth, Vietnam always has something new to discover.",
  'about.browseTours': 'Browse Our Tours',
  'about.contactUs': 'Contact Us',
  'about.heroAlt': 'Vietnam Landscape',
  'about.ctaAlt': 'Ha Long Bay Sunset',
  'about.storyAlt1': 'Guide with tourists',
  'about.storyAlt2': 'Team planning',
  'about.storyAlt3': 'Happy travelers',
  'about.licenseEyebrow': 'Official & Licensed',
  'about.licenseTitleA': 'Our Tour Operator',
  'about.licenseTitleB': 'Licence',
  'about.licenseSubtitle': 'We are a fully licensed international tour operator, authorised by the Vietnam National Authority of Tourism.',
  'about.licenseCaption': 'International Tour Operator Licence — issued by the Vietnam National Authority of Tourism.',
  'about.licenseView': 'View full licence',
  'about.licenseWhyLink': 'Discover why travellers choose us',
  'about.licenseClose': 'Close',
  'about.licenseAlt': 'Red Lion International Travel international tour operator licence',
};